import type { CatalogTree } from '../types';

// The Merchant detail frame, its header actions and the Profil and Abonelik ve ödemeler tabs
// (admin panel screens §3.4).
export const merchantDetail = {
  breadcrumb: 'İşletmeler',
  created: 'Kayıt {date}',
  notFound: 'Böyle bir işletme yok.',
  backToList: 'İşletmelere dön',
  tabsLabel: 'İşletme sekmeleri',
  subtype: { gold: 'Altın', jewelry: 'Mücevher', silver: 'Gümüş' },
  tabs: {
    profile: 'Profil',
    subscription: 'Abonelik ve ödemeler',
    invoices: 'Faturalar',
    usage: 'Kullanım ve maliyet',
    integrations: 'Entegrasyonlar ve eşitleme',
    users: 'Kullanıcılar',
    notes: 'Notlar ve işlem geçmişi',
  },
  actions: {
    extendTrial: {
      label: 'Denemeyi uzat',
      date: 'Yeni bitiş tarihi',
      description: 'Deneme süresi {date} tarihine uzatılır. Sağlayıcıdaki abonelik yenilenir.',
      pick: 'Yeni bitiş tarihini seçin.',
      done: 'Deneme süresi uzatıldı.',
    },
    specialPrice: { label: 'Özel fiyat / indirim' },
    changePlan: {
      label: 'Planı değiştir',
      plan: 'Plan',
      description: 'Yeni plan {plan} dönem sonunda ({date}) başlar; deneme sürecindeyse hemen.',
      pick: 'Yeni planı seçin.',
      done: 'Plan değişikliği kaydedildi.',
    },
    suspend: {
      label: 'Askıya al',
      reason: 'Gerekçe',
      description: 'Asistan durur; panel okunabilir kalır. Gerekçe: {reason}',
      done: 'İşletme askıya alındı.',
    },
    reactivate: {
      label: 'Yeniden etkinleştir',
      description: 'Abonelik yeniden etkinleşir ve asistan yanıt vermeye başlar.',
      done: 'Abonelik yeniden etkinleştirildi.',
      donePastDue: 'Abonelik yeniden etkinleşti; ödeme gecikmiş durumda.',
    },
    retryPayment: {
      label: 'Ödemeyi yeniden dene',
      description: 'Kayıtlı karttan {amount} çekilmeye çalışılır.',
      done: 'Ödeme yeniden denendi.',
    },
    reissueInvoice: {
      label: 'Faturayı yeniden düzenle',
      description:
        'Mevcut fatura iptal edilir ve aynı ödeme için güncel bilgilerle yeni fatura kesilir.',
      done: 'Fatura yeniden düzenleniyor.',
    },
    resync: {
      label: 'Yeniden eşitle',
      description: 'Mağazadan tam içe aktarma başlatılır; süren bir eşitleme varsa o döndürülür.',
      done: 'Eşitleme başlatıldı.',
    },
    markStepDone: {
      label: 'Adımı tamamlandı işaretle',
      description: '8. adım (Plan ve ödeme) operatör tarafından tamamlandı olarak işaretlenir.',
      done: 'Adım tamamlandı olarak işaretlendi.',
    },
    rebuildReports: {
      label: 'Raporları yeniden hesapla',
      date: 'Başlangıç tarihi',
      description: '{date} tarihinden bugüne günlük özetler yeniden hesaplanır.',
      pick: 'Başlangıç tarihini seçin (en çok 90 gün geriye).',
      done: 'Raporların yeniden hesaplanması başlatıldı.',
    },
  },
  profile: {
    identity: 'Kimlik',
    note: 'İşletme bilgilerini işletme sahibi kendi panelinden düzenler.',
    fields: {
      businessName: 'İşletme adı',
      legalName: 'Ticari unvan',
      taxId: 'Vergi numarası',
      taxOffice: 'Vergi dairesi',
      address: 'Adres',
      contactName: 'Yetkili',
      email: 'E-posta',
      phone: 'Telefon',
      sectorPack: 'Sektör paketi',
      subtype: 'Alt sektör',
      status: 'Durum',
      plan: 'Plan',
      trialEndsAt: 'Deneme bitişi',
      termsAcceptedAt: 'Sözleşme onayı',
      createdAt: 'Kayıt tarihi',
    },
    packValue: '{pack} (sürüm {version})',
    onboarding: 'Kurulum',
    steps: {
      business: 'İşletme',
      store: 'Mağaza altyapısı',
      whatsapp: 'WhatsApp',
      instagram: 'Instagram',
      assistant: 'Asistan ayarları',
      test_chat: 'Deneme sohbeti',
      install: 'Kurulum ve bildirimler',
      plan: 'Plan ve ödeme',
      go_live: 'Yayına al',
    },
    stepStatus: { pending: 'Bekliyor', done: 'Tamamlandı', skipped: 'Atlandı' },
    metrics: 'Son 30 gün',
    tiles: {
      conversations: 'Konuşmalar',
      aiHandled: 'Asistanın yanıtladığı',
      staffHandled: 'Personelin yanıtladığı',
      handoffRate: 'Devir oranı',
      medianFirstReply: 'Medyan ilk yanıt',
      confirmedSales: 'Onaylı satışlar',
      likelySales: 'Olası satışlar',
    },
    salesCount: { one: '{count} satış', other: '{count} satış' },
  },
  subscription: {
    title: 'Abonelik',
    none: 'Abonelik yok.',
    noneHint: 'İşletme, kurulumun 8. adımında (Plan ve ödeme) aboneliğini başlatır.',
    fields: {
      status: 'Durum',
      plan: 'Plan',
      interval: 'Ödeme aralığı',
      price: 'Dönem ücreti',
      discount: 'İndirim',
      provider: 'Ödeme sağlayıcısı',
      customerRef: 'Sağlayıcı müşteri kaydı',
      subscriptionRef: 'Sağlayıcı abonelik kaydı',
      card: 'Kart',
      cardExpiry: 'Son kullanma',
      trialEndsAt: 'Deneme bitişi',
      period: 'Geçerli dönem',
      cancelAtPeriodEnd: 'Dönem sonunda iptal',
      pendingChange: 'Bekleyen değişiklik',
      dunning: 'Tahsilat adımı',
      suspension: 'Askı nedeni',
    },
    interval: { monthly: 'Aylık', annual: 'Yıllık' },
    yes: 'Evet',
    no: 'Hayır',
    cardValue: '•••• {last4}',
    period: '{from} – {to}',
    pendingValue: '{plan}, {interval}, {price}; {date} tarihinde başlar',
    dunningValue: '{step}; sonraki deneme {date}',
    dunningStep: {
      none: 'Yok',
      retrying: 'Yeniden deneniyor',
      grace: 'Ek süre',
      suspended: 'Askıya alındı',
    },
    suspendedByDunning: 'Ödeme borcu nedeniyle askıda; başarılı bir ödeme ile yeniden etkinleşir.',
    suspendedByOperator: 'Operatör tarafından askıya alındı.',
    payments: 'Ödeme denemeleri',
    noPayments: 'Henüz ödeme denemesi yok.',
    columns: {
      kind: 'Tür',
      attempt: 'Deneme',
      period: 'Dönem',
      amount: 'Tutar',
      result: 'Sonuç',
      errorCode: 'Hata kodu',
      refunded: 'İade',
      providerRef: 'Sağlayıcı referansı',
      at: 'Zaman',
    },
    kind: {
      checkout: 'Ödeme başlangıcı',
      renewal: 'Yenileme',
      retry: 'Yeniden deneme',
      manual: 'Manuel',
    },
    refundedValue: '{amount}, {date}',
    refund: 'İade et',
  },
} as const satisfies CatalogTree;
